import { useMemo } from "react";
import PermissionGuard from "./PermissionGuard";
import { RESOURCES } from "@/constants/resources";
import { PermissionScope } from "@/services/AuthService";

export const UserTable = ({ users, onEdit, onDelete }) => {
    const sortedUsers = useMemo(() => {
      return [...users].sort((a, b) => {
        const first = (a.firstName || "").localeCompare(b.firstName || "");
        return first === 0 ? (a.lastName || "").localeCompare(b.lastName || "") : first;
      });
    }, [users]);
  
    return (
      <table className="users-table">
        <thead>
          <tr>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Email</th>
            <th>Access Level</th>
            <PermissionGuard resource={[RESOURCES.INTERNAL_USERS, RESOURCES.PARTNER_USERS]} scope={[PermissionScope.UPDATE, PermissionScope.DELETE]}>
              <th>Actions</th>
            </PermissionGuard>
          </tr>
        </thead>
        <tbody>
          {sortedUsers.map((user) => (
            <tr key={user.id}>
              <td>{user.firstName}</td>
              <td>{user.lastName}</td>
              <td>{user.email}</td>
              <td>{user.role || '-'}</td>
              <PermissionGuard resource={[RESOURCES.INTERNAL_USERS, RESOURCES.PARTNER_USERS]} scope={[PermissionScope.UPDATE, PermissionScope.DELETE]}>
                <td>
                  <PermissionGuard resource={[RESOURCES.INTERNAL_USERS, RESOURCES.PARTNER_USERS]} scope={PermissionScope.UPDATE}>
                    <button
                      className="btn-edit"
                      onClick={() => {
                        onEdit(user)
                      }}>
                        Edit
                    </button>
                  </PermissionGuard>
                  <PermissionGuard resource={[RESOURCES.INTERNAL_USERS, RESOURCES.PARTNER_USERS]} scope={PermissionScope.DELETE}>
                    <button
                      className="btn-delete"
                      onClick={() => {
                        onDelete(user)
                      }}>
                        Delete
                    </button>
                  </PermissionGuard>
                </td>
              </PermissionGuard>
            </tr>
          ))}
        </tbody>
      </table>
    );
};

export const UserGroup = ({ title, count, isExpanded, onToggle, children }) => (
    <div className="user-group">
      <div className="user-group-header" onClick={onToggle}>
        <div className="user-group-info">
          <span className="user-group-name">{title}</span>
          <span className="users-count">({count} user{count !== 1 ? 's' : ''})</span>
        </div>
        <span className={`collapse-icon ${isExpanded ? 'expanded' : 'collapsed'}`}>
          {isExpanded ? '▼' : '▶'}
        </span>
      </div>
      {isExpanded && children}
    </div>
);
  